<template>
  <div class="produk">
    <!-- <SearchView />    -->
    <div class="title-bar" style="background-color: #C039FF;" v-if="$q.screen.sm || $q.screen.md || $q.screen.lg || $q.screen.xl">
        <div class="row text-white" style="padding: 15px 150px;">
        <div class="col-12 col-md-6 text-left" style="font-family: 'Manrope'; font-size: 16px; font-weight: 700;">
          Detail Produk
        </div>
        <div class="col-12 col-md-6" style="font-family: 'Poppins'; font-size: 14px; font-weight: 500;">
          <q-breadcrumbs class="text-grey-4" align="right" active-color="white">
            <q-breadcrumbs-el to="/" label="Beranda" />
            <q-breadcrumbs-el label="Detail Produk" />
          </q-breadcrumbs>
        </div>
      </div>
    </div>
    <div class="title-bar" style="background-color: #C039FF;" v-if="$q.screen.lt.sm">
        <div class="row text-white" style="padding: 10px 20px;">
        <div class="col-6 text-left" style="font-family: 'Manrope'; font-size: 10px; font-weight: 600;">
          Detail Produk
        </div>
        <div class="col-6" style="font-family: 'Poppins'; font-size: 7.5px; font-weight: 500; padding-top: 2.5px;">
          <q-breadcrumbs class="text-grey-4" align="right" active-color="white">
            <q-breadcrumbs-el to="/" label="Beranda" />
            <q-breadcrumbs-el label="Detail Produk" />
          </q-breadcrumbs>
        </div>
      </div>
    </div>
    <div v-if="$q.screen.sm || $q.screen.md || $q.screen.lg || $q.screen.xl" style="margin: 50px 150px 0px; padding-bottom: 75px; border-style: none none solid none; border-width: 1px; border-color: #E9E9E9;">
        <div class="row">
            <div class="col-12 col-md-5" style="padding-right: 50px;">
                <q-img :src="file_path+produk.file" style="border-radius: 10px;" height="500px">
                  <template v-slot:loading>
                    <div class="text-purple-12">
                      <q-spinner-ios />
                    </div>
                  </template>
                </q-img>
            </div>
            <div class="col-12 col-md-7">
                <div style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 22.5px; color: #2B2B2D; margin-bottom: 15px;">
                    {{produk.brand}}
                </div>
                <div style="font-family: 'Poppins'; font-size: 14px; color: #7A7A7A; padding-bottom: 20px; border-style: none none solid none; border-width: 1px; border-color: #E9E9E9;">
                    {{produk.keterangan}}
                </div>
                <div class="row" style="padding: 20px 0;">
                    <div class="col-6 col-md-6">
                        <q-rating
                        v-model="model1"
                        max="5"
                        size="1.5em"
                        color="purple-12"
                        icon="star_border"
                        icon-selected="star"
                        icon-half="star_half"
                    />
                    </div>
                    <div class="col-6 col-md-6 text-right">
                        <q-btn @click="shareProduct()" size="sm" round no-caps style="border: 1px solid #C039FF; margin-right: 2.5px;">
                            <!-- <div style="padding: 2.5px;"> -->
                                <span class="material-symbols-outlined" style="font-weight: 600; color: #C039FF;">
                                share
                                </span>
                            <!-- </div> -->
                            <q-tooltip
                                transition-show="flip-right"
                                transition-hide="flip-left"
                                style="border: 1px solid #C039FF; color: #C039FF; background-color: white;"
                                >
                                Bagikan
                            </q-tooltip>
                        </q-btn>
                        <!-- <q-btn v-if="cek_favorite == null || cek_favorite == undefined" @click="addFavorite(produk.id, produk.kategori_id)" size="sm" round no-caps style="border: 1px solid #C039FF; margin-left: 2.5px">
                                <span class="material-symbols-outlined" style="font-weight: 600; color: #C039FF;">
                                favorite
                                </span>
                            <q-tooltip
                                transition-show="flip-right"
                                transition-hide="flip-left"
                                style="border: 1px solid #C039FF; color: #C039FF; background-color: white;"
                                >
                                Wishlist
                            </q-tooltip>
                        </q-btn>
                        <q-btn v-else @click="hapusFavorite(produk.id)" size="sm" color="purple-12" round no-caps style="border: 1px solid #C039FF; margin-left: 2.5px">
                                <span class="material-symbols-outlined" style="font-weight: 600; color: white;">
                                favorite
                                </span>
                            <q-tooltip
                                transition-show="flip-right"
                                transition-hide="flip-left"
                                style="border: 1px solid #C039FF; color: #C039FF; background-color: white;"
                                >
                                Hapus Wishlist
                            </q-tooltip>
                        </q-btn> -->
                    </div>
                </div>
                <div class="row" style="padding-bottom: 15px;">
                    <div class="col-2 col-md-2" style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 16px; font-weight: 600; color: #2B2B2D;">
                        Brand
                    </div>
                    <div class="col-10 col-md-10" style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 16px; font-weight: 400; color: #777777; padding-bottom: 7.5px;">
                        <span style="padding-right: 15px;">:</span> {{produk.brand}}
                    </div>
                    <div class="col-2 col-md-2" style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 16px; font-weight: 600; color: #2B2B2D;">
                        Kategori
                    </div>
                    <div class="col-10 col-md-10" style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 16px; font-weight: 400; color: #777777; padding-bottom: 7.5px;">
                        <span style="padding-right: 15px;">:</span> {{produk.kategori_uraian}}
                    </div>
                    <div class="col-2 col-md-2" style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 16px; font-weight: 600; color: #2B2B2D;">
                        Bahan
                    </div>
                    <div class="col-10 col-md-10" style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 16px; font-weight: 400; color: #777777; padding-bottom: 7.5px;">
                        <span style="padding-right: 15px;">:</span> Tempe
                    </div>
                    <div class="col-2 col-md-2" style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 16px; font-weight: 600; color: #2B2B2D;">
                        Stok
                    </div>
                    <div class="col-10 col-md-10" style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 16px; font-weight: 400; color: #777777; padding-bottom: 7.5px;">
                        <span style="padding-right: 15px;">:</span> {{produk.stock}}
                    </div>
                </div>
                <div v-if="produk.diskon == null || produk.diskon == 0" class="row" style="margin-bottom: 15px; padding: 15px 20px; background-color: #F8F8F8; border-radius: 5px;">
                    <!-- <span style="padding-right: 15px; padding-top: 5px; font-family: 'Poppins'; font-size: 18px; font-weight: 400; color: #7A7A7A; text-decoration: line-through; ">
                        Rp. {{produk.harga}}
                    </span> -->
                    <span style="padding-right: 15px; font-family: 'Poppins'; font-size: 25px; font-weight: bolder; color: #C039FF;">
                        Rp. {{produk.harga}}
                    </span>
                    <!-- <q-badge style="background-color: #C039FF; color: white; margin: 10px 0; font-family: 'Poppins'; font-size: 10px; font-weight: bolder;">
                        5% OFF
                    </q-badge> -->
                </div>
                <div v-else class="row" style="margin-bottom: 15px; padding: 15px 20px; background-color: #F8F8F8; border-radius: 5px;">
                    <span style="padding-right: 15px; padding-top: 5px; font-family: 'Poppins'; font-size: 18px; font-weight: 400; color: #7A7A7A; text-decoration: line-through; ">
                        Rp. {{produk.harga}}
                    </span>
                    <span style="padding-right: 15px; font-family: 'Poppins'; font-size: 25px; font-weight: bolder; color: #C039FF;">
                        Rp. {{produk.harga - (produk.harga * produk.diskon / 100)}}
                    </span>
                    <q-badge style="background-color: #C039FF; color: white; margin: 10px 0; font-family: 'Poppins'; font-size: 10px; font-weight: bolder;">
                        {{ produk.diskon }}% OFF
                    </q-badge>
                </div>
                <div class="row" style="padding: 15px 0;">
                    <div class="col-2 col-md-2" style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 16px; font-weight: 600; color: #2B2B2D;">
                        Kuantitas
                    </div>
                    <div class="col-10 col-md-10">
                        <div class="wrapper">
                            <button v-if="counter == 1" disabled class="btn" @click="changeCounter('-1', produk.stock)" type="button" name="button">-</button>
                            <button v-else class="btn" @click="changeCounter('-1', produk.stock)" type="button" name="button">-</button>
                            <input class="quantity" type="number" name="counter" :value="counter">
                            <button v-if="counter == produk.stock" disabled class="btn" @click="changeCounter('1', produk.stock)" type="button" name="button">+</button>
                            <button v-else class="btn" @click="changeCounter('1', produk.stock)" type="button" name="button">+</button>
                        </div>
                    </div>
                </div>
                <div class="row" style="margin-top: 15px;">
                    <!-- <q-btn color="purple-12" v-if="counter == 1" disabled text-color="white" style="font-family: 'Poppins'; font-weight: bold; padding: 10px 20px; margin-right: 10px;" no-caps icon="shopping_cart" label="Masukkan Keranjang" /> -->
                    <!-- <q-btn color="purple-12" @click="cekProduk(produk.id, produk.kategori_id, counter, produk.harga)" text-color="white" style="font-family: 'Poppins'; font-weight: bold; padding: 10px 20px; margin-right: 10px;" no-caps icon="payments" label="Beli Sekarang" /> -->
                    <q-btn color="purple-12" @click="beliProduk(produk.id, produk.brand, produk.pelaku_hp, counter)" text-color="white" style="font-family: 'Poppins'; font-weight: bold; padding: 10px 20px; margin-right: 10px;" no-caps icon="payments" label="Beli Sekarang" />
                    <!-- <q-btn color="white" @click="addCart(produk.id, produk.kategori_id, counter, produk.harga)" text-color="purple-12" style="border: 1px solid #C039FF; font-family: 'Poppins'; font-weight: bold; padding: 10px 45px; margin-right: 10px;" no-caps icon="payments" label="Beli Sekarang" /> -->
                </div>
            </div>
        </div>          
    </div>
    <div v-if="$q.screen.lt.sm" style="margin: 25px 20px 0px; padding-bottom: 25px; border-style: none none solid none; border-width: 1px; border-color: #E9E9E9;">
        <div class="row">
            <div class="col-5" style="padding-right: 10px;">
                <q-img :src="file_path+produk.file" style="border-radius: 10px;" height="180px">
                  <template v-slot:loading>
                    <div class="text-purple-12">
                      <q-spinner-ios />
                    </div>
                  </template>
                </q-img>
                <div class="row" style="padding-top: 5px;">
                    <div class="col-4" style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 12.5px; font-weight: 600; color: #2B2B2D; padding-top: 2.5px;">
                        Kuantitas
                    </div>
                    <div class="col-8 text-right">
                        <div class="wrapper-android">
                            <button v-if="counter == 1" disabled class="btn-android" @click="changeCounter('-1', produk.stock)" type="button" name="button">-</button>
                            <button v-else class="btn-android" @click="changeCounter('-1', produk.stock)" type="button" name="button">-</button>
                            <input class="quantity-android" type="number" name="counter" :value="counter">
                            <button v-if="counter == produk.stock" disabled class="btn-android" @click="changeCounter('1', produk.stock)" type="button" name="button">+</button>
                            <button v-else class="btn-android" @click="changeCounter('1', produk.stock)" type="button" name="button">+</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-7">
                <div style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 12.5px; color: #2B2B2D; margin-bottom: 5px;">
                    {{produk.brand}}
                </div>
                <div style="font-family: 'Poppins'; font-size: 7.5px; color: #7A7A7A; padding-bottom: 5px; border-style: none none solid none; border-width: 1px; border-color: #E9E9E9;">
                    {{produk.keterangan}}
                </div>
                <div class="row" style="padding: 5px 0;">
                    <div class="col-6 col-md-6">
                        <q-rating
                        v-model="model1"
                        max="5"
                        size="0.75em"
                        color="purple-12"
                        icon="star_border"
                        icon-selected="star"
                        icon-half="star_half"
                    />
                    </div>
                    <div class="col-6 col-md-6 text-right">
                        <q-btn @click="shareProduct()" size="0.5em" round no-caps style="border: 1px solid #C039FF; margin-right: 1.5px;">
                            <!-- <div style="padding: 2.5px;"> -->
                                <span class="material-symbols-outlined" style="font-weight: 600; color: #C039FF;">
                                share
                                </span>
                            <!-- </div> -->
                            <q-tooltip
                                transition-show="flip-right"
                                transition-hide="flip-left"
                                style="border: 1px solid #C039FF; color: #C039FF; background-color: white;"
                                >
                                Bagikan
                            </q-tooltip>
                        </q-btn>
                        <!-- <q-btn v-if="cek_favorite == null || cek_favorite == undefined" @click="addFavorite(produk.id, produk.kategori_id)" size="0.5em" round no-caps style="border: 1px solid #C039FF; margin-left: 1.5px">
                                <span class="material-symbols-outlined" style="font-weight: 600; color: #C039FF;">
                                favorite
                                </span>
                            <q-tooltip
                                transition-show="flip-right"
                                transition-hide="flip-left"
                                style="border: 1px solid #C039FF; color: #C039FF; background-color: white;"
                                >
                                Wishlist
                            </q-tooltip>
                        </q-btn>
                        <q-btn v-else @click="hapusFavorite(produk.id)" size="0.5em" color="purple-12" round no-caps style="border: 1px solid #C039FF; margin-left: 1.5px">
                                <span class="material-symbols-outlined" style="font-weight: 600; color: white;">
                                favorite
                                </span>
                            <q-tooltip
                                transition-show="flip-right"
                                transition-hide="flip-left"
                                style="border: 1px solid #C039FF; color: #C039FF; background-color: white;"
                                >
                                Hapus Wishlist
                            </q-tooltip>
                        </q-btn> -->
                    </div>
                </div>
                <div class="row" style="padding-bottom: 5px;">
                    <div class="col-3 col-md-3" style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 10px; font-weight: 600; color: #2B2B2D;">
                        Brand
                    </div>
                    <div class="col-9 col-md-9" style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 10px; font-weight: 400; color: #777777; padding-bottom: 2.5px;">
                        <span style="padding-right: 5px;">:</span> {{produk.brand}}
                    </div>
                    <div class="col-3 col-md-3" style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 10px; font-weight: 600; color: #2B2B2D;">
                        Kategori
                    </div>
                    <div class="col-9 col-md-9" style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 10px; font-weight: 400; color: #777777; padding-bottom: 2.5px;">
                        <span style="padding-right: 5px;">:</span> {{produk.kategori_uraian}}
                    </div>
                    <div class="col-3 col-md-3" style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 10px; font-weight: 600; color: #2B2B2D;">
                        Bahan
                    </div>
                    <div class="col-9 col-md-9" style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 10px; font-weight: 400; color: #777777; padding-bottom: 2.5px;">
                        <span style="padding-right: 5px;">:</span> Singkong
                    </div>
                    <div class="col-3 col-md-3" style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 10px; font-weight: 600; color: #2B2B2D;">
                        Stok
                    </div>
                    <div class="col-9 col-md-9" style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 10px; font-weight: 400; color: #777777; padding-bottom: 2.5px;">
                        <span style="padding-right: 5px;">:</span> {{produk.stock}}
                    </div>
                </div>
                <div v-if="produk.diskon == null || produk.diskon == 0" class="row" style="margin-bottom: 5px; padding: 5px 10px; background-color: #F8F8F8; border-radius: 5px;">
                    <!-- <span style="padding-right: 5px; padding-top: 2.5px; font-family: 'Poppins'; font-size: 10px; font-weight: 600; color: #7A7A7A; text-decoration: line-through; ">
                        Rp. {{produk.harga}}
                    </span> -->
                    <span style="padding-right: 5px; font-family: 'Poppins'; font-size: 12.5px; font-weight: bolder; color: #C039FF;">
                        Rp. {{produk.harga}}
                    </span>
                    <!-- <q-badge style="background-color: #C039FF; color: white; margin: 2.5px 0; font-family: 'Poppins'; font-size: 7.5px; font-weight: bolder;">
                        {{ produk.diskon }}% OFF
                    </q-badge> -->
                </div>
                <div v-else class="row" style="margin-bottom: 5px; padding: 5px 10px; background-color: #F8F8F8; border-radius: 5px;">
                    <span style="padding-right: 5px; padding-top: 2.5px; font-family: 'Poppins'; font-size: 10px; font-weight: 600; color: #7A7A7A; text-decoration: line-through; ">
                        Rp. {{produk.harga}}
                    </span>
                    <span style="padding-right: 5px; font-family: 'Poppins'; font-size: 12.5px; font-weight: bolder; color: #C039FF;">
                        Rp. {{produk.harga - (produk.harga * produk.diskon / 100)}}
                    </span>
                    <q-badge style="background-color: #C039FF; color: white; margin: 2.5px 0; font-family: 'Poppins'; font-size: 7.5px; font-weight: bolder;">
                        {{ produk.diskon }}% OFF
                    </q-badge>
                </div>
                <div class="row" style="margin-top: 5px;">
                    <!-- <q-btn color="purple-12" v-if="counter == 1" disabled text-color="white" style="font-family: 'Poppins'; font-weight: bold; padding: 10px 20px; margin-right: 10px;" no-caps icon="shopping_cart" label="Masukkan Keranjang" /> -->
                    <!-- <q-btn color="purple-12" @click="cekProduk(produk.id, produk.kategori_id, counter, produk.harga)" text-color="white" style="font-family: 'Poppins'; font-weight: bold; padding: 5px 7.5px; margin-right: 5px; font-size: 7.5px;" no-caps icon="sym_o_payments" label="Beli Sekarang" /> -->
                    <q-btn color="purple-12" @click="beliProduk(produk.id, produk.brand, produk.pelaku_hp, counter)" text-color="white" style="font-family: 'Poppins'; font-weight: bold; padding: 5px 7.5px; margin-right: 5px; font-size: 7.5px;" no-caps icon="sym_o_payments" label="Beli Sekarang" />
                    <!-- <q-btn color="white" @click="addCart(produk.id, produk.kategori_id, counter, produk.harga)" text-color="purple-12" style="border: 1px solid #C039FF; font-family: 'Poppins'; font-weight: bold; padding: 5px 7.5px; font-size: 7.5px;" no-caps icon="sym_o_payments" label="Beli Sekarang" /> -->
                </div>
            </div>
        </div>          
    </div>
    <div style="margin: 75px 150px;" v-if="$q.screen.sm || $q.screen.md || $q.screen.lg || $q.screen.xl">
        <div class="row" style="margin-bottom: 25px;">
            <div class="col-12 col-md-6 produk-title1">
                Produk Populer
                </div>
            <div class="col-12 col-md-6" style="text-align: right;">
                <q-btn to="/produk" flat no-caps color="purple-12">
                    <div class="produk-title2">Lihat Semua Produk</div>
                    <div class="produk-btn">
                    <span class="material-symbols-outlined">
                        arrow_right_alt
                    </span>
                    </div>
                </q-btn>
            </div>
        </div>
        <div class="row items-start q-col-gutter-md">
        <div class="col-12 col-md-3" v-for="data in produk_populer">
            <q-card v-ripple class="my-card cursor-pointer q-hoverable" @click="push_produk(data.id)">
                <q-img :src="file_path+data.file" height="275px">
                    <template v-slot:loading>
                    <div class="text-purple-12">
                        <q-spinner-ios />
                    </div>
                    </template>
                </q-img>

                <q-card-section style="text-align: center;">
                    <q-btn
                    round
                    color="white"
                    icon="shopping_cart"
                    text-color="purple-12"
                    size="sm"
                    style="top: -15px; transform: translateY(-50%);"
                    />
                    <div class="produk-cat">
                    {{data.kategori_uraian}}
                    </div>
                    <div style="padding-bottom: 15px;">
                    <q-rating
                    v-model="model1"
                    max="5"
                    size="1em"
                    color="purple-12"
                    icon="star_border"
                    icon-selected="star"
                    icon-half="star_half"
                    />
                    </div>
                    <q-btn no-caps flat @click="push_produk(data.id)" style="font-family: 'Poppins'; font-size: 16px; font-weight: 600; color: #2B2B2D; padding-bottom: 15px;" class="btn--no-hover" :label="data.brand" />
                    <div v-if="data.diskon == null || data.diskon == 0" class="produk-price1">Rp. {{data.harga}}</div>
                      <div v-else class="produk-price1">Rp. {{data.harga - (data.harga * data.diskon / 100)}} <span class="produk-price2"> Rp. {{data.harga}}</span></div>
                </q-card-section>
            
            </q-card>
        </div>
        </div>
    </div>
    <div style="margin: 25px 20px;" v-if="$q.screen.lt.sm">
        <div class="row" style="margin-bottom: 5px;">
            <div class="col-6 produk-title1-android">
                Produk Populer
                </div>
            <div class="col-6" style="text-align: right;">
                <q-btn to="/produk" flat no-caps color="purple-12" style="margin-top: -10px; margin-right: -15px;">
                    <div class="produk-title2-android">Lihat Semua Produk</div>
                    <div class="produk-btn-android">
                    <span class="material-symbols-outlined">
                        arrow_right_alt
                    </span>
                    </div>
                </q-btn>
            </div>
        </div>
        <div class="row items-start q-col-gutter-xs">
        <div class="col-3" v-for="data in produk_populer">
            <q-card v-ripple class="my-card cursor-pointer q-hoverable" @click="push_produk(data.id)">
                <q-img :src="file_path+data.file" height="100px">
                    <template v-slot:loading>
                    <div class="text-purple-12">
                        <q-spinner-ios />
                    </div>
                    </template>
                </q-img>

                <q-card-section style="text-align: center;">
                    <q-btn
                    round
                    color="white"
                    icon="shopping_cart"
                    text-color="purple-12"
                    size="xs"
                    style="top: -15px; transform: translateY(-50%);"
                    />
                    <div class="produk-cat-android text-no-wrap overflow-hidden" style="text-overflow: ellipsis;">
                    {{data.kategori_uraian}}
                  </div>
                  <div style="margin-top: -5px;">
                    <q-rating
                    v-model="model1"
                    max="5"
                    size="0.5em"
                    color="purple-12"
                    icon="star_border"
                    icon-selected="star"
                    icon-half="star_half"
                    />
                    </div>
                    <div class="text-center text-no-wrap overflow-hidden produk-android-title" style="text-overflow: ellipsis;">
                        {{ data.brand }}
                      </div>
                      <div v-if="data.diskon == null || data.diskon == 0" class="produk-price1-android">Rp. {{data.harga}}</div>
                      <div v-else class="produk-price1-android">Rp. {{data.harga - (data.harga * data.diskon / 100)}} <span class="produk-price2-android text-no-wrap overflow-hidden" style="text-overflow: ellipsis;"> Rp. {{data.harga}}</span></div>
                </q-card-section>
            
            </q-card>
        </div>
        </div>
    </div>
  </div>
</template>

<script>

import { useHead } from '@vueuse/head';
import SearchView from '@/views/SearchView.vue'

export default {
  name: 'ProdukDetail',
  components: {
    SearchView
  },
  data () {
    return {
        counter: 1,
        produk : '',
        cek_produk : '',
        cek_favorite : null,
        produk_populer : [],
        userId : '',
        file_path: this.$store.state.url.URL_APP + "uploads/",
    }
  },

  methods: {
    push_produk : function(id){
      this.$router.push('/produk_detail/'+id);
      setTimeout(function(){
            location.reload();
        }, 250);
    },

    getView: function() {
        // this.cek_favorite = null;
        this.cek_load_data = true;
        this.$store.commit('showLoading');
        fetch(this.$store.state.url.URL_PRODUK + "detailProduk", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            },
                body: JSON.stringify({
                id: this.$route.params.id,
            })
        })
            .then(res => res.json())
            .then(res_data => {
                console.log(res_data);
                this.produk = res_data[0];
                
                this.$store.commit("hideLoading");
            this.cek_load_data = false;
            this.updateOGTags();
            // this.changeCounter();
        });
    },

    updateOGTags() {
      if (!this.produk) return;
        console.log(this.produk.brand+this.produk.keterangan+this.file_path+this.produk.file+this.produk.id);
        
      // Update document title
      document.title = this.produk.brand;

      // Update Open Graph meta tags
      const metaTags = [
        { property: 'og:title', content: this.produk.brand },
        { property: 'og:description', content: this.produk.keterangan },
        { property: 'og:image', content: this.file_path+this.produk.file },
        { property: 'og:url', content: `https://marina.konaweselatankab.go.id/#/produk_detail/${this.produk.id}` }
      ];

      metaTags.forEach(tag => {
        let element = document.querySelector(`meta[property="${tag.property}"]`);
        if (!element) {
          element = document.createElement('meta');
          element.setAttribute('property', tag.property);
          document.head.appendChild(element);
        }
        element.setAttribute('content', tag.content);
      });
    },

    cekProduk: function(a, b, c, d) {
        if (localStorage.profile == undefined) {
            this.Notify('Silahkan Login Terlebih Dahulu', 'red-12', 'sym_o_cancel');
        } else {
            fetch(this.$store.state.url.URL_KERANJANG + "cekProduk", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            },
                body: JSON.stringify({
                produkId: a,
            })
            })
                .then(res => res.json())
                .then(res_data => {
                    console.log(res_data.data[0]);
                    this.cek_produk = res_data.data[0];
                    console.log(this.cek_produk+"CEK PRODUK");
                    if (this.cek_produk == undefined || this.cek_produk == null) {
                        this.addCart(a, b, c, d,)
                    } else {
                        this.Notify('Produk Sudah Ada Dikeranjang', 'red-12', 'sym_o_cancel');
                    }
            });
        }
    },

    shareProduct() {
    if (!this.produk) return;

    const shareUrl = `https://marina.konaweselatankab.go.id/#/produk_detail/${this.produk.id}`;
    const message = `Cek produk ini: ${this.produk.brand} - ${shareUrl}`;
    const waLink = `https://wa.me/?text=${encodeURIComponent(message)}`;
    window.open(waLink, "_blank");
  },

convertTo62(number) {
  // Ensure the input is a string
  const numStr = String(number);

  // Check if the number starts with "0"
  if (numStr.startsWith("0")) {
    // Replace "0" with "62"
    return "62" + numStr.slice(1);
  }

  // Return the number as-is if it doesn't start with "0"
  return numStr;
},


    beliProduk(id, brand, hp, counter) {

      const shareUrl = `https://marina.konaweselatankab.go.id/#/produk_detail/${id}`;
        
      const message = `Halo, Saya ingin membeli produk ${brand} sebanyak ${counter} yang anda pasarkan di Marina Market Place Kabupaten Konawe Selatan, apakah stock produk masih tersedia ? \n${shareUrl}`;
      const encodedMessage = encodeURIComponent(message); // Encode the message for a URL
      
      // Replace with your WhatsApp number
      const phoneNumber = this.convertTo62(hp); 
      
      // Generate the wa.me URL
      const waLink = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
      
      // Open the link in a new tab
      window.open(waLink, "_blank");
    },

    cekFavorite: function() {
        // var get_profile = JSON.parse(localStorage.profile);
        // this.userId = get_profile.profile.userId;
        // console.log(this.userId+"dshjfsjhf");
        fetch(this.$store.state.url.URL_WISHLIST + "cekFavorite", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            },
                body: JSON.stringify({
                produkId: this.$route.params.id,
            })
        })
            .then(res => res.json())
            .then(res_data => {
                console.log(res_data.data[0]);
                this.cek_favorite = res_data.data[0];
                console.log(this.cek_favorite+"CEK FAVORITE");
                this.getView();
        });
    },

    getProdukPopuler : function(){
      fetch(this.$store.state.url.URL_PRODUK  + "produkPopuler", {
          method: "POST",
          headers: {
          "content-type": "application/json"
          },
      })
          .then(res => res.json())
          .then(res_data => {
            console.log(res_data);
              this.produk_populer = res_data.data;
      });
    },

    addCart : function(a, b, c, d) {
      fetch(this.$store.state.url.URL_KERANJANG + "addCart", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
                produkId : a,
                kategoriId : b,
                kuantitas : c,
                total : c*d
            })
      }).then(res_data => {
          this.Notify('Produk Dimasukkan Keranjang', 'purple-12', 'check_circle_outline');
          this.getView();
      });
    },

    addFavorite : function(a, b) {
        if (localStorage.profile == undefined) {
            this.Notify('Silahkan Login Terlebih Dahulu', 'red-12', 'sym_o_cancel');
        } else {
            fetch(this.$store.state.url.URL_WISHLIST + "addFavorite", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
                produkId : a,
                kategoriId : b
            })
      }).then(res_data => {
          this.Notify('Produk Dimasukkan Wishlist', 'purple-12', 'check_circle_outline');
          this.cekFavorite();
      });   
        }
    },

    hapusFavorite : function(a){
      fetch(this.$store.state.url.URL_WISHLIST  + "hapusProduk", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({id : a})
      }).then(res_data => {
          this.Notify('Produk Dihapus Dari Wishlist', 'purple-12', 'check_circle_outline');
          this.cekFavorite();
      });

    },

    changeCounter: function(num, max){
        this.counter += +num
        console.log(this.counter)
        !isNaN(this.counter) && this.counter >= 0 && this.counter <= max ? this.counter : this.counter = 0;
    },

    Notify : function(message, color, icon){
          this.$q.notify({
            message: message,
            color: color,
            icon: icon,
            position : 'top',
            timeout: 1000,
          })
        },
  },

  mounted() {
    this.getProdukPopuler();
    this.cekFavorite();
    this.getView()
    // var get_profile = JSON.parse(localStorage.profile);
    // this.userId = get_profile.profile.userId;
    // console.log(this.userId+"Iksan Sinatra");
    // if (get_profile == 'undefined' || get_profile == 'null') {
    //     this.getView
    // } else {
    //     this.cekFavorite();
    // }
  }

}
</script>
